import AppLogoIcon from "./app-logo-icon"

export default function AppLogo() {
  return (
    <>
      <div className="text-sidebar-primary-foreground flex aspect-square size-10 items-center justify-center rounded-2xl shadow-lg ring-1 shadow-black/10 ring-white/15">
        <AppLogoIcon className="size-7 text-white" />
      </div>
      <div className="ml-3 hidden flex-1 text-left text-sm lg:grid">
        {/* <span className="text-sidebar-foreground/60 truncate text-[0.72rem] font-medium tracking-[0.24em] uppercase">
          Dividend OS
        </span> */}
        <span className="mb-0.5 truncate leading-tight font-semibold tracking-tight">
          FIREFlow
        </span>
      </div>
    </>
  )
}
